import { ORDER_SOURCE_TYPE } from '.';

export const ORDER_SOURCE_CANAL_OF_LINE_ENABLED: string[] = [ORDER_SOURCE_TYPE.OFFLINE.toString(), ORDER_SOURCE_TYPE.LICITACIONES.toString()];
